import vueInstance from "@/main";

export const toastController = vueInstance.$bvToast

export function useToast() {

    return {}
}